/**
 * Created by jinbian on 20/09/2017.
 */
import { createReducer, createActions } from 'reduxsauce';
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    sendEmail: ["email"],
    updateSubscribeStatus: ["subscribeStatus"],
});

export const NewsLetterTypes = Types;
export const INITIAL_STATE = {
    subscribeStatus: null,
    email: "",
};


export const sendEmail = (state = INITIAL_STATE, { email }) => {
    return { ...state, email };
};

export const updateSubscribeStatus = (state = INITIAL_STATE, { subscribeStatus }) => {
    return { ...state, subscribeStatus };
};

export const reducer = createReducer(INITIAL_STATE, {
    [Types.SEND_EMAIL]: sendEmail,
    [Types.UPDATE_SUBSCRIBE_STATUS]: updateSubscribeStatus,
});

export default Creators;
